import { render, staticRenderFns } from "./PContentForm.vue?vue&type=template&id=7a2b87fa"
import script from "./PContentForm.vue?vue&type=script&lang=js"
export * from "./PContentForm.vue?vue&type=script&lang=js"
import style0 from "./PContentForm.vue?vue&type=style&index=0&id=7a2b87fa&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports